import React from 'react'
import ReactDOMServer from 'react-dom/server'
import DetailTable from 'components/DetailTable'

// Job-opportunity mail sent to a college's TPO/POC when a role is published to
// that college. Carries the same "Job Details" table the institute app sends to
// students, so both audiences see identical role details.
const RoleShareToTPOTemplate = ({ data }) => {
  const {
    tpoName = 'Sir/Madam',
    collegeName = '',
    applicationDeadline = '',
    tableData = {},
    signatureName = '',
    signatureContact = '',
  } = data

  const tableContent = ReactDOMServer.renderToString(
    <DetailTable headerName="Job Details" data={tableData} />
  )

  return (
    <div
      style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#333' }}
    >
      <p>Hi {tpoName},</p>

      <p style={{ paddingTop: '8px' }}>Greetings from PluginLive!</p>

      <p style={{ paddingTop: '8px' }}>
        We have shared a new job opportunity with {collegeName} through the
        PluginLive platform
      </p>

      <div
        style={{ paddingTop: '8px' }}
        dangerouslySetInnerHTML={{ __html: tableContent }}
      />

      <p style={{ paddingTop: '8px' }}>
        Please find the complete job details attached for your reference. Kindly
        share the opportunity with the eligible students and encourage them to
        apply within the specified deadline.
      </p>

      {applicationDeadline ? (
        <p style={{ paddingTop: '8px' }}>
          <b>Application Deadline:</b> {applicationDeadline}
        </p>
      ) : null}

      <p style={{ paddingTop: '8px' }}>
        Please feel free to reach out if you need any assistance.
      </p>

      <p style={{ paddingTop: '10px', paddingBottom: '2px', margin: '0px' }}>
        Best Regards,
      </p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>
        {signatureName}
      </p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>
        PluginLive
      </p>
      <p style={{ paddingTop: '2px', paddingBottom: '2px', margin: '0px' }}>
        {signatureContact}
      </p>
    </div>
  )
}

export default RoleShareToTPOTemplate
